import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import CustomScroller from 'components/CustomScroller';
import TutorialClose from './components/TutorialClose';

function PromoCodeTutorial() {
  return (
    <Box sx={{ display: 'flex', flex: 1, flexDirection: 'column' }}>
      <Box
        sx={{
          flex: 1,
          position: 'relative',
        }}
      >
        <TutorialClose />
        <Box
          sx={{
            position: 'absolute',
            height: '100%',
            width: '100%',
          }}
        >
          <CustomScroller>
            <Box
              sx={{
                background: '#ffffff',
                flex: 1,
                borderRight: '1px solid rgba(57,76,96,.15)',
                padding: '1.5rem',
                fontSize: '14px',
              }}
            >
              <Text sx={{ fontSize: '18px', fontWeight: 700 }}>Promo Code</Text>
              <Box lineHeight="22px">
                <Text mt="1rem">
                  Promo code blocks print a code drawn from a group of codes you
                  have supplied to UnDigital in advance. Unlike other dynamic
                  blocks, the code does not come from your order post — it is
                  allocated from your supplied codes when the ad is produced.
                  Like other personalized values, it appears on a grey
                  background in the editor. The grey marks it as personalized
                  and is not printed.
                </Text>

                <Text mt="1rem" fontWeight={700}>
                  Code group
                </Text>
                <Text>
                  Identifies which of your groups of codes to draw from. You may
                  keep several groups for different promotions.
                </Text>

                <Text mt="1rem" fontWeight={700}>
                  Sample code
                </Text>
                <Text>
                  Optional. A representative code, such as SAVE15NOW, shown on
                  the canvas and in previews in place of a real one. Use it to
                  check how a code of the length you expect fits the space. It
                  is never given to a customer. Leave blank to show a generic
                  placeholder instead.
                </Text>

                <Text mt="1rem" fontWeight={700}>
                  Start and end dates
                </Text>
                <Text>
                  Optional. Limit the period during which new codes are handed
                  out. Outside that window no code is allocated and the block is
                  left off the ad entirely, so the rest of the ad still prints.
                  Leave either blank to leave that end open.
                </Text>

                <Text mt="1rem" fontWeight={700}>
                  Expires after
                </Text>
                <Text>
                  Optional. How long a code stays valid, counted from the day it
                  was allocated. On its own this prints nothing — to show the
                  date, name a field below. Leave blank if your codes do not
                  expire.
                </Text>

                <Text mt="1rem" fontWeight={700}>
                  Expiry date field name
                </Text>
                <Text>
                  Optional. The expiry date is not printed beside the code.
                  Instead it is carried in a field you name here, and you add a
                  separate text block that shows it. That way the date can sit
                  anywhere, in any font, with your own wording.
                </Text>
                <Text mt="0.5rem">
                  Name the field here — “promo_exp”, say — then add a text
                  block and insert the same name as a personalization token.
                  The token menu lists the names you have used, so you do not
                  have to retype them. Your text block might read “(expires{' '}
                  {'{{promo_exp}}'})” or “You have until {'{{promo_exp}}'} to
                  use this code”.
                </Text>
                <Text mt="0.5rem">
                  The two names must match exactly. A date needs an expiry
                  period, so “Expires after” has to be set as well.
                </Text>

                <Text mt="1rem">
                  Each order keeps the code it was first given, so reprinting an
                  order shows the same code the customer already received rather
                  than consuming another — even after the end date has passed.
                  The expiry date is counted from that original day, so a
                  reprint shows the date the customer already has.
                </Text>

                <Text mt="1rem">
                  If no code can be given out — the group has run dry, or the
                  window has closed — the code and its expiry date are both left
                  off the ad, so you never get a stray date with no code beside
                  it.
                </Text>

                <Text mt="1rem">
                  Previewing an ad template never uses up a real code. The
                  preview shows the sample code above, or a generic placeholder
                  if you have not set one.
                </Text>

                <Text mt="1rem">
                  If your supplied codes for a group run out, the block is left
                  off the ad rather than blocking the order, so it is worth
                  keeping an eye on how many codes remain.
                </Text>
              </Box>
            </Box>
          </CustomScroller>
        </Box>
      </Box>
    </Box>
  );
}
export default PromoCodeTutorial;
